module.exports = __webpack_public_path__ + "img/franciacorta.4f0c43f9.jpg";